// Vendors
import { useEffect, useMemo } from 'react';
// Event Handlers
import { ScrollTopHandlers } from '../handlers/scroll-top.handlers';
// Types
import { ScrollTopComponentType } from '../types/scroll-top.component.type';

const useScrollTopHook = ({ state }: ScrollTopComponentType): void => {
  const { handleScrollToTopInEveryViewEvent } = useMemo<ReturnType<typeof ScrollTopHandlers>>(
    () => ScrollTopHandlers(),
    []
  );

  useEffect(() => {
    handleScrollToTopInEveryViewEvent();
  }, [state]);
};

export { useScrollTopHook };
